import { MessageCircle } from 'lucide-react'; // Puedes usar cualquier ícono o un logo de WhatsApp
import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '+593959135599'; // ← Reemplaza con tu número (código de país incluido)

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50 transition-all duration-300"
      aria-label="Chatear por WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
};

export default WhatsAppButton;
